import { useEffect } from 'react';

export function Home() {

  useEffect(() => {
    window.location.href = 'https://moonproduct.tech/solo';
  }, []);

  return null;
}